/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Drop_FrameInputs */

const en_dialogue_list_export_drop_frame = /** @type {(inputs: Dialogue_List_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop frame`)
};

const fr_dialogue_list_export_drop_frame = /** @type {(inputs: Dialogue_List_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop frame`)
};

const de_dialogue_list_export_drop_frame = /** @type {(inputs: Dialogue_List_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallrahmen`)
};

const it_dialogue_list_export_drop_frame = /** @type {(inputs: Dialogue_List_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telaio a goccia`)
};

const ru_dialogue_list_export_drop_frame = /** @type {(inputs: Dialogue_List_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опускающаяся рама`)
};

const es_dialogue_list_export_drop_frame = /** @type {(inputs: Dialogue_List_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marco de caída`)
};

const zh_cn2_dialogue_list_export_drop_frame = /** @type {(inputs: Dialogue_List_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`掉帧`)
};

const ja_dialogue_list_export_drop_frame = /** @type {(inputs: Dialogue_List_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドロップフレーム`)
};

const hi_dialogue_list_export_drop_frame = /** @type {(inputs: Dialogue_List_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्रॉप फ्रेम`)
};

const pt_pt2_dialogue_list_export_drop_frame = /** @type {(inputs: Dialogue_List_Export_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadro de queda`)
};

/**
* | output |
* | --- |
* | "Drop frame" |
*
* @param {Dialogue_List_Export_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_drop_frame = /** @type {((inputs?: Dialogue_List_Export_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_drop_frame(inputs)
	if (locale === "de") return de_dialogue_list_export_drop_frame(inputs)
	if (locale === "it") return it_dialogue_list_export_drop_frame(inputs)
	if (locale === "ru") return ru_dialogue_list_export_drop_frame(inputs)
	if (locale === "es") return es_dialogue_list_export_drop_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_drop_frame(inputs)
	if (locale === "ja") return ja_dialogue_list_export_drop_frame(inputs)
	if (locale === "hi") return hi_dialogue_list_export_drop_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_drop_frame(inputs)
	return en_dialogue_list_export_drop_frame(inputs)
});